import { useQuery } from '@tanstack/react-query';
import { isMockAuthEnabled } from '@/app/msal';
import { fetchMarketplaceAccess, type HttpError } from '../ssoClient';
import { mockEntitlement } from '../mockEntitlement';

// Excluded from localStorage persistence in app/providers.tsx — a suspended or
// cancelled entitlement must never be served from the cross-session cache.
export const marketplaceAccessQueryKey = ['marketplace-access'] as const;

export function errorStatus(error: unknown): number | undefined {
  return (error as Partial<HttpError> | null)?.status;
}

/**
 * Non-suspense on purpose: `EntitlementGuard` sits above the app shell's
 * Suspense boundary and renders its own loading / 401 / 403 states.
 */
export function useMarketplaceAccess() {
  return useQuery({
    queryKey: marketplaceAccessQueryKey,
    queryFn: isMockAuthEnabled ? () => Promise.resolve(mockEntitlement) : fetchMarketplaceAccess,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: true,
    retry: (failureCount, error) => {
      const status = errorStatus(error);
      if (status === 401 || status === 403) return false;
      return failureCount < 1;
    },
  });
}
